import type {
  LoginPayload,
  LoginSuccessResponse,
  MessageSuccessResponse,
  RecoveryPayload,
} from '@/types/auth'
import axios from 'axios'

const loginApiCall = async (
  abortController?: AbortController,
  params?: LoginPayload,
): Promise<LoginSuccessResponse> => {
  const { data } = await axios.post(
    '/auth/login',
    { ...params },
    { signal: abortController?.signal },
  )
  return data.data
}

const refreshTokenApiCall = async (
  abortController?: AbortController,
): Promise<LoginSuccessResponse> => {
  const { data } = await axios.get(
    '/auth/refresh',
    { signal: abortController?.signal },
  )
  return data.data
}

const registerApiCall = async (
  abortController?: AbortController,
  params?: FormData,
): Promise<MessageSuccessResponse> => {
  const { data } = await axios.postForm(
    '/auth/register',
    params,
    { signal: abortController?.signal },
  )
  return data.data
}

const passwordRecoveryApiCall = async (
  abortController?: AbortController,
  params?: RecoveryPayload,
): Promise<MessageSuccessResponse> => {
  const { data } = await axios.post(
    '/reset-password-link',
    { ...params },
    { signal: abortController?.signal },
  )
  return data.data
}

export { loginApiCall, passwordRecoveryApiCall, refreshTokenApiCall, registerApiCall }
